module.exports = __webpack_public_path__ + "static/media/default-team-member.bcb79497.png";